export type SectionKey
  = | 'customerReview'
    | 'compo'
    | 'ecodesign'
    | 'benefits'
    | 'teaser'
    | 'availability'
    | 'manufacture'
    | 'figures'
    | 'moq'

export interface SectionRowMap {
  span: number
  row: Partial<Record<SectionKey, number>>
  dividerRow: Partial<Record<SectionKey, number>>
  lastSection: SectionKey | null
}

// Rows 1–4 are always fixed: image, technicity, basicInfo, first-divider
const FIXED_ROWS = 4

export const SECTION_ORDER: SectionKey[] = [
  'compo',
  'ecodesign',
  'benefits',
  'teaser',
  'availability',
  'manufacture',
  'figures',
  'moq',
]

/**
 * Assigns sequential grid-row positions to the visible sections.
 * Each section takes 2 rows (content + divider), except `moq` which takes 1.
 * All cards sharing the same customView produce the same map.
 */
export function buildRowMap(sectionOrder: SectionKey[], visibleSections: ReadonlySet<SectionKey>): SectionRowMap {
  const row: Partial<Record<SectionKey, number>> = {}
  const dividerRow: Partial<Record<SectionKey, number>> = {}
  let currentRow = FIXED_ROWS + 1
  let lastSection: SectionKey | null = null

  for (const key of sectionOrder) {
    if (!visibleSections.has(key))
      continue
    lastSection = key
    row[key] = currentRow
    if (key === 'moq') {
      currentRow += 1
    }
    else {
      dividerRow[key] = currentRow + 1
      currentRow += 2
    }
  }

  return {
    span: Math.max(FIXED_ROWS, currentRow - 1),
    row,
    dividerRow,
    lastSection,
  }
}
